<template>
  <section class="text-main-400 px-4 mt-8 mb-16 text-left">
    <h4 class="text-lg font-bold pb-4">
      <slot />
    </h4>

    <article class="flex flex-wrap">
      <div
        v-for="item in list"
        :key="item.pk"
        class="cursor-pointer transition-all duration-200 m-2 px-3 py-1 border border-main-400 rounded hover:bg-secondary-200 hover:border-secondary-400 hover:text-secondary-400"
        :class="{ selected: itemIsSelected(item.slug) }"
        @click="applyFilters(item)"
      >
        {{ item[field] }}
      </div>
    </article>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    list: {
      type: Array,
      required: true,
    },

    selected: {
      type: Array,
      required: true,
    },

    mutation: {
      type: String,
      required: true,
    },

    field: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState('videos', ['videosAction', 'selectedSpeakers', 'selectedTags']),
  },

  methods: {
    itemIsSelected(slug) {
      return this.selected.includes(slug)
    },

    applyFilters(item) {
      this.$store.dispatch(`videos/setSelected${this.mutation}`, item.slug)

      // Update url when selecting filter
      let url = this.$route.path
      if (this.selectedTags.length) {
        const tagsString = this.selectedTags.join(',')
        url = `${this.$route.path}?tags=${tagsString}`
      }
      window.history.pushState('', '', url)

      this.$store.dispatch(`videos/${this.videosAction}`, {
        slug: this.$route.params.slug,
      })
    },
  },
}
</script>

<style scoped>
.selected,
.selected:hover {
  @apply bg-secondary-500 border-secondary-500 text-white;
}
</style>
